var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"shop-button lundi",attrs:{"type":"button","name":"button"},on:{"click":_vm.addToCart}},[(_vm.preorder)?[_vm._v("Pre-order")]:[_vm._v("Ajouter au panier")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }